import { Capacitor } from '@capacitor/core';
import { App } from '@capacitor/app';
import { FirebaseMessaging } from '@capacitor-firebase/messaging';
import { notificationsAPI } from './api';

const DEVICE_ID_KEY = 'myhomeentryPushDeviceId';

export const getPushDeviceId = () => {
  let deviceId = localStorage.getItem(DEVICE_ID_KEY);
  if (!deviceId) {
    deviceId = typeof crypto?.randomUUID === 'function'
      ? crypto.randomUUID()
      : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    localStorage.setItem(DEVICE_ID_KEY, deviceId);
  }
  return deviceId;
};

export const registerPushToken = async (token) => {
  // App.getInfo() can fail to return on some Android WebViews. Do not let
  // optional version metadata block device-token registration.
  const appInfo = await Promise.race([
    App.getInfo().catch(() => ({})),
    new Promise(resolve => setTimeout(() => resolve({}), 1000))
  ]);
  return notificationsAPI.registerDevice({
    deviceId: getPushDeviceId(),
    token,
    platform: Capacitor.getPlatform(),
    appVersion: appInfo.version
  });
};

export const unregisterPushDevice = async () => {
  if (!Capacitor.isNativePlatform()) return;
  const deviceId = localStorage.getItem(DEVICE_ID_KEY);
  if (deviceId) await notificationsAPI.unregisterDevice(deviceId).catch(() => {});
  await FirebaseMessaging.deleteToken().catch(() => {});
};
